import { Box } from "./Box";
import { BoxProps } from "./boxHelpers";
import { useTranslation } from "../stores/RootStoreContext";
import { ReactElement, useState } from "react";
import { Button } from "./Button";

export interface ListFieldProps extends BoxProps {
  data?: ReactElement[] | ReactElement | string;
}

export interface ListItemProps extends BoxProps {
  fields: ListFieldProps[];
}

export interface ListProps extends BoxProps {
  openLabel?: string;
  closeLabel?: string;
  collapseSize?: number;
  allBorders?: boolean;
  list: ListItemProps[];
  headData?: ListFieldProps[];
}

function ListField({ data, ...props }: ListFieldProps) {
  return <Box {...props}>{data}</Box>;
}

function ListItem({ fields, ...props }: ListItemProps) {
  return (
    <Box paddingY={"sm"} grow justifyContent="space-between" {...props}>
      {fields.map((item, index) => (
        <ListField {...item} key={index} />
      ))}
    </Box>
  );
}

export function List({
  allBorders = false,
  list,
  headData,
  collapseSize,
  openLabel,
  closeLabel,
  ...props
}: ListProps) {
  const { t } = useTranslation();

  const [isCollapse, setCollapse] = useState<boolean>(true);

  return (
    <Box display={"block"} grow {...props}>
      {headData?.length ? <ListItem fields={headData} /> : null}
      {list.slice(0, isCollapse && collapseSize ? collapseSize : list.length).map((item, index) => (
        <ListItem
          key={index}
          borderBottom={allBorders ? false : index !== list.length - 1}
          {...item}
        />
      ))}
      {collapseSize && (
        <>
          <Button
            variant={"primary"}
            label={isCollapse ? openLabel || t("list.showMore") : closeLabel || t("list.showLess")}
            onClick={() => setCollapse(!isCollapse)}
          />
        </>
      )}
    </Box>
  );
}
